import Card from "../../../componentLibrary/Card";
import { Permission, Role } from "../../../types/rbac";

interface RoleDetailsProps {
  role: Role | null;
  allPermissions: Permission[];
}

const RoleDetails = ({ role, allPermissions }: RoleDetailsProps) => {
  if (!role) {
    return (
      <Card>
        <div className="text-center py-12 text-gray-500">
          Select a role from the list to view details
        </div>
      </Card>
    );
  }

  return (
    <Card title="Role Details">
      <div className="space-y-4">
        <div>
          <span className="font-semibold">Display Name:</span>{" "}
          {role.displayName}
        </div>
        <div>
          <span className="font-semibold">Internal Name:</span>{" "}
          <code className="text-xs bg-gray-100 px-2 py-1 rounded">
            {role.name}
          </code>
        </div>
        <div>
          <span className="font-semibold">Description:</span>{" "}
          {role.description || "No description"}
        </div>
        <div>
          <span className="font-semibold">
            Permissions ({role.permissions.length}):
          </span>
          <div className="mt-2 space-y-1">
            {role.permissions.length > 0 ? (
              role.permissions.map((perm) => {
                const permDetail = allPermissions.find((p) => p.id === perm);
                return (
                  <div
                    key={perm}
                    className="text-sm bg-gray-100 px-3 py-2 rounded"
                  >
                    <code className="font-mono text-sm">{perm}</code>
                    {permDetail && (
                      <div className="text-gray-600 text-xs mt-1">
                        {permDetail.description}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="text-gray-500 text-sm">
                No permissions assigned
              </div>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default RoleDetails;
